import { defineMessages } from '../define';

/** Song page: sheet viewer, connectors, practice-audio player, lyrics. */
export const viewer = defineMessages(
  {
    'viewer.tab_sheet': 'Nótur',
    'viewer.tab_lyrics': 'Texti',
    'viewer.tabs_label': 'Nótur eða texti',
    'viewer.sheets_label': 'Nótnaskrár',
    'viewer.lyrics_files_label': 'Textar',
    'viewer.all_files': 'Allar skrár',
    'viewer.all_files_hint': 'Sýna líka skrár fyrir aðrar raddir',
    'viewer.audio_show': 'Sýna spilara',
    'viewer.audio_hide': 'Fela spilara',
    'viewer.audio_short': 'Hljóð',
    'viewer.page_indicator': '{page} / {count}',
    'viewer.bars_fold': 'Fela stikur',
    'viewer.bars_fold_hint': 'Nóturnar fá allan skjáinn; einn hnappur kallar stikurnar fram aftur',
    'viewer.bars_show': 'Sýna stikur',
    'viewer.bars_button_hint': 'Ýttu til að sýna stikurnar; dragðu hnappinn að hvaða brún sem er',
    'viewer.bars_pin': 'Festa stikur',
    'viewer.bars_pin_hint': 'Stikurnar haldast efst (nóturnar minnka)',
    'viewer.bars_close': 'Fela stikurnar aftur',
    'viewer.page_aria': 'Síða {page} af {count}',
    'viewer.page_label': 'Síða {page}',
    'viewer.jump_back': 'Til baka',
    'viewer.jump_to': 'Hoppa á síðu {page}',
    'viewer.jump_to_label': '{label} – hoppa á síðu {page}',
    'viewer.loading': 'Hleð nótum…',
    'viewer.load_failed': 'Ekki tókst að hlaða nótunum.',
    'viewer.load_offline': 'Nóturnar eru ekki vistaðar á þessu tæki og ekkert netsamband er.',
    'viewer.load_forbidden': 'Þú hefur ekki lengur aðgang að þessum nótum.',
    'viewer.rev_changed': 'Nóturnar hafa verið uppfærðar. Sæki nýjustu útgáfu…',
    'viewer.rev_loaded': 'Ný útgáfa af nótunum var opnuð.',
    'viewer.hq_failed': 'Skýrari útgáfa náðist ekki.',
    'viewer.no_sheet': 'Engar nótur í þessu lagi',
    'viewer.no_sheet_audio_hint': 'Þú getur hlustað á æfingahljóðin hér fyrir neðan.',
    'viewer.no_files': 'Engar skrár í þessu lagi',
    'viewer.no_files_hint': 'Engar nótur, hljóðskrár eða textar eru aðgengilegir þér í þessu lagi enn.',
    'viewer.song_not_found': 'Lagið fannst ekki',
    'viewer.song_not_found_hint': 'Því gæti hafa verið eytt, eða þú hefur ekki aðgang að því.',
    'viewer.song_offline': 'Lagið er ekki vistað á tækinu',
    'viewer.song_offline_hint': 'Opnaðu lagið með nettengingu eða vistaðu það fyrir notkun án nets.',
    'viewer.song_error': 'Ekki tókst að opna lagið',
    'viewer.to_songs': 'Í lagasafnið',
    'viewer.demo_to_end': 'Á lokasíðu',
    'viewer.demo_to_start': 'Á upphaf',
    'viewer.lyrics_smaller': 'Minna letur',
    'viewer.lyrics_larger': 'Stærra letur',
    'viewer.lyrics_contrast': 'Skýr birtuskil',
    'viewer.lyrics_size': 'Leturstærð {size}',
    'viewer.lyrics_empty': 'Enginn texti',
    'viewer.lyrics_empty_hint': 'Enginn söngtexti hefur verið settur inn fyrir þetta lag.',
    'viewer.audio_player': 'Spilari',
    'viewer.audio_tracks': 'Hljóðskrár',
    'viewer.audio_play': 'Spila',
    'viewer.audio_pause': 'Gera hlé',
    'viewer.audio_back5': 'Aftur um 5 sek.',
    'viewer.audio_fwd5': 'Áfram um 5 sek.',
    'viewer.audio_seek': 'Staða í hljóðskrá',
    'viewer.audio_speed': 'Hraði',
    'viewer.audio_speed_value': '{rate}×',
    'viewer.audio_slower': 'Hægar',
    'viewer.audio_faster': 'Hraðar',
    'viewer.audio_speed_reset': 'Venjulegur hraði',
    'viewer.audio_loop': 'Endurtaka kafla',
    'viewer.audio_set_a': 'Setja A',
    'viewer.audio_set_b': 'Setja B',
    'viewer.audio_clear_loop': 'Hreinsa',
    'viewer.audio_loop_on': 'Endurtekur {a}–{b}',
    'viewer.audio_loop_hint': 'Ýttu á „Setja A“ þar sem kaflinn byrjar og „Setja B“ þar sem hann endar.',
    'viewer.audio_more': 'Fleiri stillingar',
    'viewer.audio_error': 'Ekki tókst að spila hljóðskrána.',
    'viewer.audio_offline': 'Hljóðskráin er ekki vistuð á tækinu og ekkert netsamband er.',
    'viewer.audio_none': 'Engar hljóðskrár í þessu lagi',
    'viewer.audio_own_section': 'Þín rödd',
    'viewer.audio_time': '{time} af {duration}',
    'viewer.spread_indicator': '{first}–{last} / {count}',
    'viewer.spread_aria': 'Síður {first}–{last} af {count}',
    'viewer.layout_two_up': 'Tvær síður',
    'viewer.layout_two_up_hint': 'Tvær síður hlið við hlið – ýttu á hægri eða vinstri hluta skjásins, eða strjúktu, til að fletta',
    'viewer.setlist_label': 'Lagalisti: {name}',
    'viewer.setlist_prev': 'Fyrra',
    'viewer.setlist_next': 'Næsta',
    'viewer.setlist_prev_song': 'Fyrra lag',
    'viewer.setlist_next_song': 'Næsta lag',
    'viewer.setlist_position': '{position} / {total}',
    'viewer.setlist_position_aria': 'Lag {position} af {total}',
    'viewer.next_song': 'Næsta lag',
    'viewer.next_song_hint': 'Ýttu aftur á „áfram“ til að opna næsta lag',
    'viewer.two_up_hint': 'Ýttu á hægri eða vinstri hluta skjásins, eða strjúktu, til að fletta',
    'viewer.mode_label': 'Útlit síðu',
    'viewer.mode_scroll': 'Samfellt',
    'viewer.mode_scroll_hint': 'Allar síður í einni samfelldri röð – skrunaðu',
    'viewer.mode_page': 'Heil síða',
    'viewer.mode_page_hint': 'Ein heil síða í einu – ýttu hægra eða vinstra megin til að fletta',
    'viewer.first_page': 'Fyrsta síða',
    'viewer.last_page': 'Síðasta síða',
  },
  {
    'viewer.tab_sheet': 'Sheet',
    'viewer.tab_lyrics': 'Lyrics',
    'viewer.tabs_label': 'Sheet music or lyrics',
    'viewer.sheets_label': 'Sheet files',
    'viewer.lyrics_files_label': 'Lyrics',
    'viewer.all_files': 'All files',
    'viewer.all_files_hint': 'Also show files for other sections',
    'viewer.audio_show': 'Show player',
    'viewer.audio_hide': 'Hide player',
    'viewer.audio_short': 'Audio',
    'viewer.page_indicator': '{page} / {count}',
    'viewer.bars_fold': 'Hide the bars',
    'viewer.bars_fold_hint': 'The sheet gets the whole screen; one button brings the bars back',
    'viewer.bars_show': 'Show the bars',
    'viewer.bars_button_hint': 'Tap to show the bars; drag the button to any edge',
    'viewer.bars_pin': 'Keep the bars',
    'viewer.bars_pin_hint': 'The bars stay at the top (the sheet gets smaller)',
    'viewer.bars_close': 'Hide the bars again',
    'viewer.page_aria': 'Page {page} of {count}',
    'viewer.page_label': 'Page {page}',
    'viewer.jump_back': 'Back',
    'viewer.jump_to': 'Jump to page {page}',
    'viewer.jump_to_label': '{label} – jump to page {page}',
    'viewer.loading': 'Loading sheet music…',
    'viewer.load_failed': 'Could not load the sheet music.',
    'viewer.load_offline': 'This sheet music is not saved on this device and you are offline.',
    'viewer.load_forbidden': 'You no longer have access to this sheet music.',
    'viewer.rev_changed': 'The sheet music has been updated. Fetching the latest version…',
    'viewer.rev_loaded': 'A new version of the sheet music was opened.',
    'viewer.hq_failed': 'The sharper version could not be loaded.',
    'viewer.no_sheet': 'No sheet music for this song',
    'viewer.no_sheet_audio_hint': 'You can listen to the practice tracks below.',
    'viewer.no_files': 'No files for this song',
    'viewer.no_files_hint': 'No sheet music, audio or lyrics are available to you for this song yet.',
    'viewer.song_not_found': 'Song not found',
    'viewer.song_not_found_hint': 'It may have been deleted, or you do not have access to it.',
    'viewer.song_offline': 'This song is not saved on this device',
    'viewer.song_offline_hint': 'Open the song while online, or save it for offline use.',
    'viewer.song_error': 'Could not open the song',
    'viewer.to_songs': 'Go to the library',
    'viewer.demo_to_end': 'To last page',
    'viewer.demo_to_start': 'To the start',
    'viewer.lyrics_smaller': 'Smaller text',
    'viewer.lyrics_larger': 'Larger text',
    'viewer.lyrics_contrast': 'High contrast',
    'viewer.lyrics_size': 'Text size {size}',
    'viewer.lyrics_empty': 'No lyrics',
    'viewer.lyrics_empty_hint': 'No lyrics have been added for this song.',
    'viewer.audio_player': 'Player',
    'viewer.audio_tracks': 'Audio tracks',
    'viewer.audio_play': 'Play',
    'viewer.audio_pause': 'Pause',
    'viewer.audio_back5': 'Back 5 s',
    'viewer.audio_fwd5': 'Forward 5 s',
    'viewer.audio_seek': 'Position in track',
    'viewer.audio_speed': 'Speed',
    'viewer.audio_speed_value': '{rate}×',
    'viewer.audio_slower': 'Slower',
    'viewer.audio_faster': 'Faster',
    'viewer.audio_speed_reset': 'Normal speed',
    'viewer.audio_loop': 'Repeat a passage',
    'viewer.audio_set_a': 'Set A',
    'viewer.audio_set_b': 'Set B',
    'viewer.audio_clear_loop': 'Clear',
    'viewer.audio_loop_on': 'Repeating {a}–{b}',
    'viewer.audio_loop_hint': 'Tap “Set A” where the passage starts and “Set B” where it ends.',
    'viewer.audio_more': 'More settings',
    'viewer.audio_error': 'Could not play the track.',
    'viewer.audio_offline': 'This track is not saved on this device and you are offline.',
    'viewer.audio_none': 'No audio tracks for this song',
    'viewer.audio_own_section': 'Your section',
    'viewer.audio_time': '{time} of {duration}',
    'viewer.spread_indicator': '{first}–{last} / {count}',
    'viewer.spread_aria': 'Pages {first}–{last} of {count}',
    'viewer.layout_two_up': 'Two pages',
    'viewer.layout_two_up_hint': 'Two pages side by side – tap the right or left part of the screen, or swipe, to turn',
    'viewer.setlist_label': 'Setlist: {name}',
    'viewer.setlist_prev': 'Previous',
    'viewer.setlist_next': 'Next',
    'viewer.setlist_prev_song': 'Previous song',
    'viewer.setlist_next_song': 'Next song',
    'viewer.setlist_position': '{position} / {total}',
    'viewer.setlist_position_aria': 'Song {position} of {total}',
    'viewer.next_song': 'Next song',
    'viewer.next_song_hint': 'Press “next” again to open the next song',
    'viewer.two_up_hint': 'Tap the right or left part of the screen, or swipe, to turn the page',
    'viewer.mode_label': 'Page layout',
    'viewer.mode_scroll': 'Continuous',
    'viewer.mode_scroll_hint': 'All pages in one continuous column – scroll',
    'viewer.mode_page': 'Whole page',
    'viewer.mode_page_hint': 'One whole page at a time – tap the right or left side to turn',
    'viewer.first_page': 'First page',
    'viewer.last_page': 'Last page',
  },
);
